import { gql } from '@apollo/client';

export default gql`
  query spaces($page: Int) {
    user {
      canAddSpace
      ownedSpacesTotal
    }

    spaces(page: $page) {
      spacesTotalPages
      spacesTotal
      spaces {
        id
        name
        role
      }
    }
      
    invitedSpaces(page: 1) {
      spacesTotalPages
      spacesTotal
      perPage
      hasNextPage
      currentPage
      spaces {
        id
        name
        role
        usersTotal
      }
    }
  }
`;
